<template>
<div>
  test
  <ul v-if="posts && posts.length">
    <li v-for="post of posts" :key="post.id">
      <p><strong>{{post.properties.city}}</strong></p>
      <p>{{post.body}}</p>
    </li>
  </ul>

  <ul v-if="errors && errors.length">
    <li v-for="error of errors" :key="error">
      {{error.message}}
    </li>
  </ul>
</div>
</template>

<script>
import {HTTPgouv} from '../services/http-common'

export default {
  data () {
    return {
      posts: [],
      errors: []
    }
  },

  // Fetches posts when the component is created.
  async created () {
    HTTPgouv.get(`search`, {params: {'q': '8 Rue du port'}})
      .then(response => {
        this.posts = response.data.features
        console.log(response.data) // properties
      })
      .catch(e => {
        this.errors.push(e)
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/HelloWorld.vue